import useCache from '../hooks/use-cache';
import { useGetContentQuery } from '../store';

function useLocalization() {

    const localizationKey = 'localization';
    const {data} = useCache(localizationKey, useGetContentQuery, localizationKey);

    let localization = {};

    if(data && data.length > 0){
        localization = data[0].content;
    }

    return localization;
}
export default useLocalization;